import { inject } from '@angular/core';
import { StationsService } from '../../../services';

/** when extending this class be sure to implement ngOnInit */
export class NgxAimStationComplete {
  // ngOnInit() {
  //   this.init();
  // }

  stationsService = inject(StationsService);

  selectedGroup = this.stationsService.getSelectedGroup();
  selectedStation = this.stationsService.getSelectedStation();
  selectedTime = this.stationsService.getSelectedTime();
  selectedDate = this.stationsService.getSelectedDate();
  selectedDuration = this.stationsService.getSelectedDuration();
  selectedAmountOfGuests = this.stationsService.selectedAmountOfGuests;
  Notes = this.stationsService.Notes;
  allowedGuestMessage = this.stationsService.allowedGuetsMessage;

  init() {
    this.stationsService.reset();
  }
}